// Copyright 2026 The Gitea Authors. All rights reserved.
// SPDX-License-Identifier: MIT
import {createApp} from 'vue';

export async function initAgentOperations() {
  const el = document.querySelector<HTMLElement>('#agent-operations');
  if (!el) return;

  const pageData = window.config.pageData.agentOperations;
  if (!pageData) return;

  try {
    const {default: AgentOperations} = await import('../components/AgentOperations.vue');
    createApp(AgentOperations, {pageData}).mount(el);
    el.classList.remove('is-loading');
  } catch (err) {
    console.error('AgentOperations failed to load', err);
    el.textContent = 'Agent operations failed to load';
  }
}
